var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportTennis24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44929",
    "data-name": "Group 44929",
    transform: "translate(-1183 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Sport",
    "data-name": "icon/Sport",
    transform: "translate(7349 14427)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14086",
    "data-name": "Rectangle 14086",
    width: 24,
    height: 24,
    transform: "translate(-6166 -13566)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_Sport-2",
    "data-name": "icon/Sport",
    d: "M412,373.833a7.985,7.985,0,0,0,2.886,6.145,9.99,9.99,0,0,0,0-12.29A7.987,7.987,0,0,0,412,373.833Zm-11.5,7.6a9.988,9.988,0,0,0,13,0,9.993,9.993,0,0,1,0-15.192,9.99,9.99,0,0,0-13,0,9.993,9.993,0,0,1,0,15.192Zm-1.386-13.741a9.99,9.99,0,0,0,0,12.29,7.986,7.986,0,0,0,0-12.29Z",
    transform: "translate(-6561 -13927.833)",
    fill: "#8d939c"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportTennis24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_tennis24x24.fe2a4d0edfad66f5e2aed71ba5f3e0bb.svg";